import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { Deployment } from 'src/app/core/models/deployment';
import { addUserRoles } from 'src/app/core/models/user';
import { UserRoleNames, UserRolesInt } from 'src/app/core/models/users';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-attach-deployment',
  templateUrl: './attach-deployment.component.html',
  styleUrls: ['./attach-deployment.component.scss']
})
export class AttachDeploymentComponent implements OnInit {

  deploymentNames = this.data.deploymentNames;
  attachDeploymentForm: UntypedFormGroup;
  userName = this.data.userName;
  adminId = this.data.adminId;
  types: addUserRoles[] = [
    { name: UserRoleNames.DeploymentAdmin, value: UserRolesInt.DeploymentAdmin },
    // { name: UserRoleNames.PowerUser, value: UserRolesInt.PowerUser },
    { name: UserRoleNames.JobOperator, value: UserRolesInt.JobOperator },
  ];
  isGroupsAccessControl: boolean = this.data?.isGroupsAccessControl || false;
  deployments: Deployment[];
  groups: string[] = [];
  isVdi: boolean = false;

  constructor(
    public dialog: MatDialogRef<AttachDeploymentComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      userName: string,
      adminId: string,
      deploymentNames: string[],
      isGroupsAccessControl: boolean;
      jobSubmitUserId: string;
      sessionUserId: string;
    },
    private depService: DeploymentService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.spinner.show()
    this.depService
      .getAllDeploymentsForUser()
      .subscribe({
        next: (data) => {
          try{
            if (data == null) {
              this.spinner.hide()
            } else {
              this.deployments = <Deployment[]>JSON.parse(JSON.stringify(data));
              if (this.deployments.length == 0) {
                this.spinner.hide();
                return;
              }
              if (this.deployments.length == 1) {
                this.isVdi = this.deployments[0].isVdi;
              }
              this.spinner.hide();
            }
          }
          catch(e){
            this.spinner.hide()
          }
        },
        error: (err) => {
          this.spinner.hide()
        }
      })
    this.attachDeploymentForm = new UntypedFormGroup({
      deploymentName: new UntypedFormControl('', [Validators.required]),
      userRole: new UntypedFormControl('', [Validators.required]),
      jobSubmitUserId: new UntypedFormControl(this.userName),
      nodeGroup: new UntypedFormControl(''),
      addUserToCluster: new UntypedFormControl(true),
      userSessionId: new UntypedFormControl(this.userName)
    })
    if(!this.isGroupsAccessControl) {
      this.attachDeploymentForm.get('nodeGroup').setValidators([Validators.required]);
    }

    this.attachDeploymentForm.get('userRole').valueChanges.subscribe(roleName => {
      if(roleName == UserRolesInt.DeploymentAdmin) {
        this.attachDeploymentForm.get('nodeGroup').setValue(this.groups);
        this.attachDeploymentForm.get('nodeGroup').disable();
      } else {
        this.attachDeploymentForm.get('nodeGroup').setValue(null);
      }
    });
  }

  onClose() {
    this.dialog.close()
  }

  onSubmit(form) {
    if(form.status == "INVALID"){
      this.attachDeploymentForm.markAllAsTouched();
      return;
    }
    let attachObj = {
      "userName": this.userName,
      "adminId": this.adminId,
      "depName": form.value.deploymentName,
      "userRole": form.value.userRole,
      "jobSubmitId": form.value.jobSubmitUserId,
      "nodeGroup": form.value.nodeGroup?.toString(),
      "addUserToCluster": form.value.addUserToCluster || this.isVdi,
      "sessionUserId": form.value.userSessionId
    }

    this.dialog.close(attachObj);
  }

  deploymentChange(depName) {
    if(!depName) {
      this.groups = []
      return;
    }
    if(!this.deployments && this.deployments.length == 0){
      this.groups = []
      return;
    }
    this.groups = this.deployments.find(x => x.name == depName)?.nodeGroup?.split(',') || [];
    this.isVdi = this.deployments.find(x => x.name == depName)?.isVdi || false;
  }
}
